
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Firebase, Game } from '../../Core'

import * as indicatorsSelectors from '../../Mars/Indicators/indicators.selectors'
import * as indicatorsActions from '../../Mars/Indicators/indicators.actions'

import * as audioActions from '../../Core/Game/AudioContainer/audio.actions'
import * as MapActions from '../../Mars/Map/map.actions'
import * as MapSelectors from '../../Mars/Map/map.selectors'

// import * as profileActions from '../../Mars/Profile/profile.actions'

import IndicatorContainer from '../../Mars/Indicators/IndicatorContainer'
import SessionCounter from '../../Mars/Components/SessionCounter'
import UserShield from '../../Mars/Components/UserShield'
import PointsAlert from '../../Mars/PointsManager/PointsAlert'
import BasicToast from '../../Mars/Toast/BasicToast'
import SettingsMenuButton from '../../Mars/Settings/SettingsMenuButton'
import HelpButton from '../../Mars/Settings/HelpButton'
import Feed from '../../Mars/Ranking/Feed'

import * as SavePointSelectors from '../../Mars/SavePoint/savePoint.selectors'

import TileButton from '../../Mars/Map/MapScreen/TilePopup/TileButton'
import GlobeAlert from '../../Mars/Components/GlobeAlert'
import DocumentsButton from '../../Mars/Documents/DocumentsButton/index'

import * as tutorialActions from '../tutorial.actions'

import * as tutorialSelectors from '../tutorial.selectors'

import ViewContainer from './ViewContainer/index'

class MapScreen extends React.Component {
  /****/

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { getCountDisputes } = this.props
    getCountDisputes()
  }

  handleLoadPlayer(uid) {
    const { loadVisitorMap, visitorMap } = this.props
    if (!visitorMap.mapId) {
      loadVisitorMap(uid)
    }
  }

  displayButton(label, icon, action, disabled = false) {
    const { addHowlSound } = this.props
    icon ? addHowlSound('button_click_icon') : addHowlSound('button_click')

    return (
      <TileButton
        key={label + '_' + icon}
        label={label}
        icon={icon}
        action={action}
        disabled={disabled}
      />
    )
  }

  renderUserButtons() {
    const { currentPhase, changeTurn, addPopup, visitorMap, groupData, userData, mapUI } =
      this.props

    let isLastTurn = false
    if (userData.turn % groupData.maxTurns === 0) {
      isLastTurn = true
    }

    return (
      <div className="map--buttons">
        {mapUI.nextTurnButton && currentPhase == 3 && !visitorMap.mapId
          ? isLastTurn
            ? this.displayButton('phase.lastTurn', null, () => {
                addPopup('last_turn_popup')
              })
            : this.displayButton('phase.nextTurn', null, () => {
                changeTurn()
              })
          : null}
      </div>
    )
  }

  renderShield(data) {
    const cityLevel = 'map.buildings.city_level.' + (data.cityLevel ? data.cityLevel : 1)

    return [
      data.colonyShield ? <UserShield key="shield" shield={data.colonyShield} /> : null,
      <div key="block_info" className="map--block__info">
        <span className="text username">{data.colonyName}</span>
        <span className="text">
          <FormattedMessage id={cityLevel} />
        </span>
        <span className="text">{data.name}</span>
        <span className="num">
          <span className="icon-settlers"></span>
          {data.settlers}
        </span>
      </div>,
    ]
  }

  handleBackToRanking() {
    const {
      addScreen,
      addHowlSound,
      setListenerType,
      setVisitorMap,
      setVisitorIndicators,
      clearSprites,
      backToRanking,
      saveVisitorMap,
    } = this.props
    addHowlSound('button_click')
    addScreen('ranking_screen')
    backToRanking(true)

    setTimeout(() => {
      addHowlSound('button_click_icon')
      setListenerType(null)
      clearSprites()
      saveVisitorMap()
      setVisitorMap({ visitorId: null, mapId: null, buildings: {}, removedRocks: {} })
      setVisitorIndicators(null)
      addHowlSound('button_click_icon')
    }, 1000)
  }

  renderUserHeader() {
    const { playerData, visitorInfo, userIndicators, getProfileBattles, mapUI } = this.props

    const VisitingShield = (
      <div key="user_shield" className="map--block map--header">
        {this.renderShield(playerData)}
      </div>
    )
    const userShield = (
      <div key="ownShield">
        <UserShield
          key="shield"
          openProfile={() => getProfileBattles()}
          shield={playerData.colonyShield}
        />
        <div className="player--position">
          <div className="player--label">
            <FormattedMessage id="ranking.position" defaultMessage="position" />
          </div>
          <div className="player--position__item">{playerData.position}º</div>
        </div>
      </div>
    )

    return (
      <React.Fragment>
        {visitorInfo ? (
          <div
            key="back_button"
            onClick={() => this.handleBackToRanking()}
            className="position--absolute left top z-index1"
          >
            <div className="btn--back">
              <span className="icon-back"> </span>
            </div>
          </div>
        ) : null}
        {mapUI.userShield && (!visitorInfo ? userShield : VisitingShield)}
        {mapUI.helpButton && <HelpButton key="help" />}
        {mapUI.settings && <SettingsMenuButton key="settings" />}
        {mapUI.indicators && (
          <IndicatorContainer
            indicators={userIndicators}
            isVisitor={false}
            key="indicators"
            position="position--absolute center top z-index5"
          ></IndicatorContainer>
        )}
        {mapUI.documents && <DocumentsButton key={'documents'} />}
      </React.Fragment>
    )
  }

  renderFooter() {
    const { visitorInfo, visitorIndicators } = this.props
    if (!visitorInfo) {
      return null
    }

    return (
      <React.Fragment>
        <div key="footer" className="map--block map--footer">
          {this.renderShield(visitorInfo)}
        </div>
        <IndicatorContainer
          indicators={visitorIndicators}
          isVisitor={true}
          key="indicators"
          position="position--absolute center bottom z-index5 markers--footer"
        ></IndicatorContainer>
      </React.Fragment>
    )
  }

  render() {
    const { alertData, visitorInfo, isAttacking, mapUI } = this.props

    const MapBorders = () => (
      <div className="map--picture">
        <span className="map--picture__borders"> </span>
      </div>
    )
    return (
      <div className="map">
        {this.renderUserHeader()}
        <PointsAlert />
        {mapUI.sessionCounter && <SessionCounter />}
        <BasicToast />
        {mapUI.globeAlert && alertData && <GlobeAlert {...alertData} />}
        {this.renderUserButtons()}
        {visitorInfo && isAttacking ? <MapBorders /> : null}
        <ViewContainer />
        {this.renderFooter()}
        {mapUI.feed && visitorInfo && (
          <Feed className="z-index6" user={visitorInfo} visitUser={true} />
        )}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  // hardcoded no need to mock
  getCountDisputes: () => console.log('get count disputes'),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  clearSprites: bindActionCreators(MapActions.clearSprites, dispatch),

  // to mock?
  toggleAttack: bindActionCreators(MapActions.toggleAttack, dispatch),
  setListenerType: bindActionCreators(Firebase.actions.setListenerType, dispatch),

  // to mock
  setVisitorIndicators: bindActionCreators(indicatorsActions.setVisitorIndicators, dispatch),

  // mocked
  saveVisitorMap: bindActionCreators(tutorialActions.saveVisitorMap, dispatch),
  backToRanking: bindActionCreators(tutorialActions.backToRanking, dispatch),
  setVisitorMap: bindActionCreators(tutorialActions.setVisitorMap, dispatch),
  loadVisitorMap: bindActionCreators(tutorialActions.loadVisitorMap, dispatch),
  getProfileBattles: bindActionCreators(tutorialActions.getProfileBattles, dispatch),
  changeTurn: bindActionCreators(tutorialActions.nextTurn, dispatch),
  addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
  removePopup: bindActionCreators(tutorialActions.removePopup, dispatch),
  addPopup: bindActionCreators(tutorialActions.addPopup, dispatch),
})
const mapStateToProps = (state) => ({
  // to mock?
  isAttacking: MapSelectors.getAttackState(state),
  alertData: SavePointSelectors.getAlertData(state),

  // to mock
  visitorIndicators: indicatorsSelectors.getVisitorIndicators(state),

  visitorMap: tutorialSelectors.getVisitorMap(state),
  visitorInfo: tutorialSelectors.getVisitorInfo(state),
  playerData: tutorialSelectors.getCurrentUser(state),
  groupData: tutorialSelectors.getGroupData(state),
  userIndicators: tutorialSelectors.getIndicators(state),
  myUID: tutorialSelectors.getOwnPlayerID(state),
  playerList: tutorialSelectors.getPlayerList(state),
  currentPhase: tutorialSelectors.getCurrentPhase(state),
  currentUser: tutorialSelectors.getUserData(state),
  userData: tutorialSelectors.getUserData(state),
  mapUI: tutorialSelectors.getMapUI(state),
})

MapScreen.propTypes = {
  changeTurn: PropTypes.func,
  backToRanking: PropTypes.func,
  loadVisitorMap: PropTypes.func,
  setListenerType: PropTypes.func,
  saveVisitorMap: PropTypes.func,
  removePopup: PropTypes.func,
  setVisitorMap: PropTypes.func,
  setVisitorIndicators: PropTypes.func,
  clearSprites: PropTypes.func,
  toggleAttack: PropTypes.func,
  getProfileBattles: PropTypes.func,
  playerList: PropTypes.object,
  isAttacking: PropTypes.bool,
  alertData: PropTypes.object,
  visitorMap: PropTypes.object,
  currentUser: PropTypes.object,
  visitorInfo: PropTypes.object,
  myUID: PropTypes.string,
  currentPhase: PropTypes.number,
  playerData: PropTypes.object,
  groupData: PropTypes.object,
  visitorIndicators: PropTypes.array,
  userIndicators: PropTypes.array,
  userData: PropTypes.object,
  addPopup: PropTypes.func,
  addScreen: PropTypes.func,
  addHowlSound: PropTypes.func,
  getCountDisputes: PropTypes.func,
  mapUI: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(MapScreen)
